import React from 'react';
import PropTypes from 'prop-types';

import AdvWorkflow from '../AdvWorkflow/AdvWorkflowContainer';
import Mortgage from './Steps/Mortgage/MortgageContainer';
import PlanToGetMortgage from './Steps/PlanToGetMortgage/PlanToGetMortgageContainer';
import DownPayment from './Steps/DownPayment/DownPaymentContainer';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

const MortgageWorkflowView = ({ branch, workflowId }) => (
  <AdvWorkflow
    branch={branch}
    workflowId={workflowId}
    steps={[PlanToGetMortgage, DownPayment, Mortgage]}
  />
);

MortgageWorkflowView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default MortgageWorkflowView;
